import {
  MatrixMembership,
  SjMatrixMessageType,
  SystemMessageAction
} from '@/types/matrix';
import {TFunction} from 'i18next';
import {MatrixEvent, EventType} from 'matrix-js-sdk';
import {isNameChangeEvent} from '../room';

export const getSystemMessageText = (
  event: MatrixEvent,
  t: TFunction,
  senderName?: string,
  isDirect?: boolean
): string | null => {
  const content = event.getContent();
  const prevContent = event.getPrevContent();
  const effectiveEvent = event.getEffectiveEvent();
  switch (event.getType()) {
    case EventType.RoomMessage:
    case EventType.RoomMember:
      if (content.membership === MatrixMembership.JOIN) {
        if (isNameChangeEvent(event)) {
          const oldName = prevContent.displayname as string;
          const newName = content.displayname as string;
          return t(SystemMessageAction.NameChange, {
            oldName,
            newName
          });
        }

        return t(SystemMessageAction.RoomJoined, {
          user: senderName || effectiveEvent.sender
        });
      } else if (content.membership === MatrixMembership.INVITE && isDirect) {
        return t(SystemMessageAction.MemberInvited, {
          user: effectiveEvent.content.displayname
        });
      } else if (content.membership === MatrixMembership.KNOCK) {
        return t(SystemMessageAction.Knocked, {
          user: senderName || effectiveEvent.sender
        });
      }

      if (prevContent.membership === MatrixMembership.INVITE) {
        return t(SystemMessageAction.InviteRejected, {
          user: senderName || effectiveEvent.sender
        });
      } else if (content.membership === MatrixMembership.LEAVE) {
        return t(SystemMessageAction.RoomLeft, {
          user: senderName || effectiveEvent.sender
        });
      }

      return null;
    case EventType.RoomCreate:
      return t(SystemMessageAction.RoomCreated);
    case SjMatrixMessageType.SystemMessage:
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return t(`system_messages:${content.body}` as any, {
        user:
          event.getContent().data.user || senderName || effectiveEvent.sender
      });
    case SjMatrixMessageType.Metadata:
      return t(SystemMessageAction.RoomMetadata, {
        user: senderName || effectiveEvent.sender
      });
    default:
      return event.getType();
  }
};
